import { FunctionComponent, PropsWithChildren } from 'react';

import { FormControl } from '@mui/material';

import BaseFormInputField from '../../../../../shared/components/base-input-form-field/base-form-input-field';
import { ExceptedAppsReleaseFormProps } from '../types/excepted-apps-release-form-props.type';

export const AndroidMinSdkVersionInput: FunctionComponent<
  ExceptedAppsReleaseFormProps
> = (props: PropsWithChildren<ExceptedAppsReleaseFormProps>) => {
  const { values, errors, touched, handleChange, handleBlur } = props;

  return (
    <FormControl>
      <BaseFormInputField
        id="android-min-sdk-version"
        label="Android Min SDK Version"
        name="androidMinSDKVersion"
        onBlur={handleBlur}
        onChange={handleChange}
        error={!!errors.androidMinSDKVersion && touched.androidMinSDKVersion}
        helperText={
          !!errors.androidMinSDKVersion &&
          touched.androidMinSDKVersion &&
          errors.androidMinSDKVersion
        }
        value={values?.androidMinSDKVersion ?? ''}
        InputLabelProps={{ required: true }}
      />
    </FormControl>
  );
};
